import { request } from 'api';

export class KbApi {
  static getArticleByUrlName(urlName) {
    return request(`kb/${encodeURIComponent(urlName)}`);
  }
}
